/**
 * The app's data layer. Pages import from here and don't care where the data lives:
 *   VITE_API_MODE=http  → the LOVE CPMD API (shared database, real logins)          ./http.ts
 *   VITE_API_MODE=mock  → this browser only (prototype / static demo, sample data)   ./mock.ts
 * Both files export the same functions with the same signatures (checked by TypeScript below).
 */
import * as http from "./http";
import * as mock from "./mock";

export { ApiError, type ApiErrorCode } from "./errors";
export { UNAUTHORIZED_EVENT } from "./http";

export const API_MODE: "http" | "mock" = import.meta.env.VITE_API_MODE === "mock" ? "mock" : "http";

const impl: typeof mock = API_MODE === "http" ? http : mock;

export const {
  login,
  changePassword,
  getMembers,
  getGuestPresenters,
  getCategories,
  getSessions,
  getSummaries,
  getRotations,
  getActivity,
  getSettings,
  getNotifications,
  getPrefs,
  recordSummaryView,
  createSchedule,
  updateTopic,
  reschedule,
  swapSchedules,
  markDone,
  assignReplacement,
  cancelSession,
  logSpontaneous,
  fillFromRotation,
  saveSummary,
  generateRotation,
  reorderRotation,
  lockRotation,
  unlockRotation,
  markNotificationRead,
  markAllNotificationsRead,
  syncReminders,
  updateProfile,
  updateAvatar,
  updatePrefs,
  addMember,
  updateMember,
  resetPassword,
  addCategory,
  updateCategory,
  addGuestPresenter,
  updateGuestPresenter,
  updateSettings,
  resetData,
  exportData,
} = impl;

/** Online mode only: who is signed in (from the cookie), and signing out on the server. */
export const { currentUser, signOut } = http;
